var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEye(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 17.218,
    height: 11.397,
    viewBox: "0 0 17.218 11.397",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_673",
    "data-name": "Raggruppa 673",
    transform: "translate(-965.176 -1017.103)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_672",
    "data-name": "Raggruppa 672"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_671",
    "data-name": "Raggruppa 671"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_670",
    "data-name": "Raggruppa 670"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_669",
    "data-name": "Raggruppa 669"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Componente_76_2",
    "data-name": "Componente 76 \\u2013 2",
    transform: "translate(965.818 1017.603)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_651",
    "data-name": "Raggruppa 651"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_650",
    "data-name": "Raggruppa 650",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_649",
    "data-name": "Raggruppa 649"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_648",
    "data-name": "Raggruppa 648"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_1264",
    "data-name": "Tracciato 1264",
    d: "M8.917,12.963a2.871,2.871,0,0,1-.5-1.628,2.915,2.915,0,1,1,2.915,2.915",
    transform: "translate(-3.368 -6.138)",
    fill: "none",
    stroke: "#6b6b6b",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_1265",
    "data-name": "Tracciato 1265",
    d: "M14.709,4.892A9.4,9.4,0,0,0,10.182,3.73,9.586,9.586,0,0,0,2.765,7.3a2.693,2.693,0,0,0,0,3.261,9.493,9.493,0,0,0,14.835,0,2.693,2.693,0,0,0,0-3.261",
    transform: "translate(-2.215 -3.73)",
    fill: "none",
    stroke: "#6b6b6b",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  })))))))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEye);
export default __webpack_public_path__ + "static/media/eye.30aa2a74c5809906412042ba0369a361.svg";
export { ForwardRef as ReactComponent };